var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6826 16.2168C12.8048 20.3875 16.2239 23.7919 20.3946 25.9288L23.6369 22.6866C24.0348 22.2887 24.6243 22.156 25.1401 22.3329C26.7907 22.8782 28.5739 23.1729 30.4014 23.1729C31.2119 23.1729 31.8751 23.8361 31.8751 24.6467V29.7901C31.8751 30.6006 31.2119 31.2638 30.4014 31.2638C16.5629 31.2638 5.34766 20.0486 5.34766 6.21008C5.34766 5.39952 6.01084 4.73633 6.8214 4.73633H11.9795C12.7901 4.73633 13.4533 5.39952 13.4533 6.21008C13.4533 8.05226 13.748 9.82076 14.2933 11.4714C14.4554 11.9872 14.3375 12.5619 13.9249 12.9746L10.6826 16.2168Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDoodle);
export default __webpack_public_path__ + "static/media/phoneDoodle.37e2845fcfa465c209e351c23c3cf2b9.svg";
export { ForwardRef as ReactComponent };